import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeInsuranceAdLandingDetails } from '../components/HomeInsuranceAdLandingContent';
import '../components/CarInsuranceAdLandingContent.css';

const QUOTE_PATH = '/get-quote?type=home';

function HoustonHomeHero() {
  return (
    <div className="car-ad-hero car-ad-hero--compact">
      <h1 className="car-ad-hero-title">Home insurance in Houston — Lowest Rate Guaranteed</h1>
      <p className="car-ad-hero-compare-line">
        We compare prices across multiple carriers so you don&apos;t have to.
      </p>
      <Link to={QUOTE_PATH} className="btn btn-primary car-ad-hero-cta car-ad-hero-cta--emphasis">
        Click here to get a quote and save $500
      </Link>
    </div>
  );
}

function HoustonTrustBullets() {
  return (
    <ul className="car-ad-trust-list" aria-label="Why GetSkimp">
      <li>Stress free insurance shopping — we compare rates for you.</li>
      <li>No flood of spam calls.</li>
      <li>Lowest rate guaranteed — or get a $20 gift card.</li>
    </ul>
  );
}

function HoustonHomeInsuranceLandingPage() {
  const [openFaqExtra, setOpenFaqExtra] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Houston Home Insurance Quotes | GetSkimp';
    sessionStorage.setItem('insuranceType', 'home');
    sessionStorage.setItem('houstonAdMarket', 'home');
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="container car-ad-landing-page">
      <HoustonHomeHero />
      <HoustonTrustBullets />

      <div className="car-ad-form-details-divider" aria-hidden="true">
        <span>Learn more</span>
      </div>

      <HomeInsuranceAdLandingDetails />

      <div className="car-ad-landing-details">
        <section className="car-ad-section">
          <h2 className="car-ad-section-title">Houston homeowners, we get it</h2>
          <p className="car-ad-body-copy">
            Hail, wind, roof age, and flood questions come up on almost every Houston quote. We shop
            carriers that fit your home — including Katy, Sugar Land, The Woodlands, Cypress,
            Pearland, Spring, and nearby ZIP codes — and we will tell you plainly what a standard
            homeowners policy does and does not cover.
          </p>
        </section>

        <section className="car-ad-section car-ad-faq-section">
          <h2 className="car-ad-section-title">Houston home questions</h2>
          <div className="car-ad-faq-list">
            <div className={`car-ad-faq-item${openFaqExtra ? ' car-ad-faq-item--open' : ''}`}>
              <button
                type="button"
                id="houston-home-lowest-quote-trigger"
                className="car-ad-faq-trigger"
                aria-expanded={openFaqExtra}
                aria-controls="houston-home-lowest-quote-panel"
                onClick={() => setOpenFaqExtra((v) => !v)}
              >
                <span>What does “Lowest Rate Guaranteed” mean?</span>
                <span
                  className={`car-ad-faq-chevron${openFaqExtra ? ' car-ad-faq-chevron--open' : ''}`}
                  aria-hidden
                />
              </button>
              {openFaqExtra && (
                <div
                  id="houston-home-lowest-quote-panel"
                  role="region"
                  aria-labelledby="houston-home-lowest-quote-trigger"
                  className="car-ad-faq-panel"
                >
                  <p>
                    We compare rates from the carriers GetSkimp works with and present the most
                    competitive options for your home and profile. If we cannot beat a qualifying
                    competing quote you share with us, you receive a $20 gift card of your choosing.
                    Ask us for current gift card options and eligibility details.
                  </p>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default HoustonHomeInsuranceLandingPage;
